import { Select } from "@planningcenter/doxy-web"
import { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import { useHouseholds } from "source/myChurchCenter/ProfileAndHousehold/hooks/useHouseholds"
import { useSearchParams } from "source/myChurchCenter/hooks/useSearchParams"

export function ProfileSelect({ profileId }: { profileId: string }) {
  const [searchParams, setSearchParams] = useSearchParams()

  const { data: households } = useHouseholds()

  const household =
    households.find(
      (household) => household.id === searchParams.get("household"),
    ) || households[0]

  const [selected, setSelected] = useState(profileId)

  function handleChangeOrBlur(
    event:
      | React.ChangeEvent<HTMLSelectElement>
      | React.FocusEvent<HTMLSelectElement>,
  ) {
    setSelected(event.target.value)
  }

  useEffect(() => {
    setSearchParams((s) => {
      s.set("profile", selected)
      return s
    })
  }, [selected, setSearchParams])

  if (!household) return null

  return (
    <div className="d-f ai-c g-2 mb-3">
      <Select
        id="profile"
        onBlur={(e) => handleChangeOrBlur(e)}
        onChange={(e) => handleChangeOrBlur(e)}
        value={selected}
      >
        {household.householdMembers.map((member) => (
          <Select.Option
            key={member.personId}
            label={member.name}
            value={member.personId}
          />
        ))}
      </Select>
      <div className="d-f ai-c jc-fe">
        <Link
          className="btn secondary-btn compact-btn mr-1"
          to={`/households/${household.id}/household-members/new?type=adult`}
        >
          Add adult
        </Link>
        <Link
          className="btn secondary-btn compact-btn mr-1"
          to={`/households/${household.id}/household-members/new?type=child`}
        >
          Add child
        </Link>
      </div>
    </div>
  )
}
